import { OptimizationScenario, TerritoryOptimizationJob } from 'app/models';

export const findPipeUuidForScenario = (
  optimizedTerritoryInProgress: TerritoryOptimizationJob,
  selectedScenario: OptimizationScenario
): string | null =>
  optimizedTerritoryInProgress?.pipes?.find((pipe) => pipe.optimizationType === selectedScenario)?.pipeUuid ?? null;
